/* Inline-edit controller for the consolidated Profile page
   (/account/personal-info/). Each card with `data-lb-profile-card`
   toggles between display + edit states via `.lb-profile-card--editing`.

   Edit button shows the form + focuses the first input. Cancel hides
   the form and resets every input back to its initial value so a
   discarded edit doesn't linger if the user re-opens it. Submit lets
   the form post normally — the backend redirects back here with a flash
   message. */

const EDITING_CLASS = 'lb-profile-card--editing';

export function attachProfileCard(card: HTMLElement): void {
	const editBtn = card.querySelector<HTMLButtonElement>('[data-lb-profile-action="edit"]');
	const cancelBtn = card.querySelector<HTMLButtonElement>('[data-lb-profile-action="cancel"]');
	const form = card.querySelector<HTMLFormElement>('[data-lb-profile-form]');
	if (!editBtn || !cancelBtn || !form) {
		return;
	}
	const inputs = Array.from(form.querySelectorAll<HTMLInputElement>('input.mdc-text-field__input'));
	const initialValues = new Map<HTMLInputElement, string>(inputs.map(i => [i, i.value]));
	const firstInput = card.querySelector<HTMLInputElement>('[data-lb-profile-input]') || inputs[0] || null;

	editBtn.addEventListener('click', () => {
		card.classList.add(EDITING_CLASS);
		if (firstInput) {
			firstInput.focus();
			if (firstInput.type === 'text') {
				firstInput.select();
			}
		}
	});

	cancelBtn.addEventListener('click', () => {
		inputs.forEach(input => {
			input.value = initialValues.get(input) || '';
		});
		card.classList.remove(EDITING_CLASS);
	});
}

export function attachAllProfileCards(): void {
	Array.from(document.querySelectorAll<HTMLElement>('[data-lb-profile-card]')).forEach(attachProfileCard);
}
